export default __webpack_public_path__ + "static/media/key.4ba29469.svg";